import 'react-app-polyfill/ie11';
import 'core-js/features/array';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import AppProviders from './AppProviders';
// import AxiosInterceptor from './components/AxiosInterceptor/AxiosInterceptor';

import 'kenna-error-handler/dist/index.css';
// import { KennaErrorHandler } from 'kenna-error-handler';

import './styles/colors.scss';
import './styles/index.scss';

ReactDOM.render(
  <React.StrictMode>
    {/* <AxiosInterceptor /> */}
    {/* <KennaErrorHandler
      logRoute="/mmr/api/logError"
      look="basf"
      returnLink={{ text: 'return home', link: '/mmr/' }}
    > */}
      {/* <AppProviders> */}
        <App />
      {/* </AppProviders> */}
    {/* </KennaErrorHandler> */}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
